import { createAction, props } from "@ngrx/store"

import { LoginRequest } from "../models/login-request"

export const loginRequest = createAction("[Login Page] Login Request", props<{ request: LoginRequest }>())

export const loginSuccess = createAction("[Login Page] User Login")

export const loginError = createAction("[Login Page] Login Error", props<{ error: Error }>())

export const loadUserInfo = createAction("[User Info Resolver] Load user info")

export const saveUser = createAction("[User Info Resolver] Save User", props<{ user: any }>())

export const startRefreshInterval = createAction("[Init app] Init Refresh Interval")

export const refreshInterval = createAction("[Init app] Start Refresh Interval")

export const logout = createAction("[Sidebar] Logout")
